import { Log } from '../../shared/log';
import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';
import { AuthHttp, AuthHttpError } from 'angular2-jwt';
import { IVehicleRegistration } from '../../interfaces/interfaces';
import { UserEvents } from './user.events';
import { AppConfig } from '../../app.config';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import { BroadcastService } from '../broadcast/broadcast.service';

const log = new Log('TmrService');

@Injectable()
export class TmrService {
  private serverUrl;
  private vehicleRegistrationUrl;

  constructor(
      private http: Http,
      private authHttp: AuthHttp,
      private userEvents: UserEvents,
      private appConfig: AppConfig,
      private broadcastService: BroadcastService
  ) {
    this.serverUrl = appConfig.getValue('endPoint');
    this.vehicleRegistrationUrl = this.serverUrl + 'vehicleregistrations';
    this.userEvents.loggedIn.subscribe(this.onLoggedIn.bind(this));
    this.vehicleRegistrationUrl = this.serverUrl + 'vehicleregistrations';
  }

  onLoggedIn() {
    log.debug('onLoggedIn');
  }

  getVehicleRegistration(plateNo: string): Promise<IVehicleRegistration> {
    log.debug('plateNo: ', plateNo);

    return this.authHttp
      .get(this.vehicleRegistrationUrl + '/' + plateNo)
      .toPromise()
      .then(response => {
        log.debug('response: ', response, response.json());
        return response.json();
      }, error => {
        log.debug('error: ', error);
        this.handleError(error);
        return null;
      })
      .catch(this.handleError);
  }

  isValidVehicleRegistration(plateNo: string): Promise<any> {
    log.debug('step 1 plateNo: ', plateNo);

    return this.getVehicleRegistration(plateNo)
        .then((vehicleRegistration: IVehicleRegistration) => {

          if (vehicleRegistration === undefined || vehicleRegistration === null) {
            return Promise.reject('No response');
          }
          return Promise.resolve(vehicleRegistration.plateNo !== undefined && vehicleRegistration.plateNo !== null);
        })
        .catch((error) => {
          this.handleError(error);
          return Promise.reject('No response');
        });
  }

  private handleError(error: any) {
    log.error(error);

    if (error instanceof AuthHttpError) {
      const errorMessage = {
        message: 'Session Error',
        payload: error
      };
      this.broadcastService.broadcast(errorMessage);
    }
    return Promise.reject(error);
  }
}



// WEBPACK FOOTER //
// ./app/services/user/tmr.service.ts